var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#147F26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 15C19.49 15 15 19.49 15 25C15 30.51 19.49 35 25 35C30.51 35 35 30.51 35 25C35 19.49 30.51 15 25 15ZM29 25.75H25.75V29C25.75 29.41 25.41 29.75 25 29.75C24.59 29.75 24.25 29.41 24.25 29V25.75H21C20.59 25.75 20.25 25.41 20.25 25C20.25 24.59 20.59 24.25 21 24.25H24.25V21C24.25 20.59 24.59 20.25 25 20.25C25.41 20.25 25.75 20.59 25.75 21V24.25H29C29.41 24.25 29.75 24.59 29.75 25C29.75 25.41 29.41 25.75 29 25.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAdd);
export default __webpack_public_path__ + "static/media/active_add.be17ae6304911e1e1f2159e19c261d77.svg";
export { ForwardRef as ReactComponent };